import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { EditorType } from 'src/app/samwebDescription/samweb/editorType';
import { PresentationType } from 'src/app/samwebDescription/samweb/settings/presentationType';
import { ConfigurableEditorSettingRemoteDto } from 'src/generated/swagger';

export class ChangeCallTagIdForSingleCallTagBrickSettings {
   public static readonly type = '[SingleCallTagBrickSettings] Change callTagId for single call tag brick settings';

   constructor(public brickInstanceId, public callTagId: string) {}
}

export class ChangeIsReadOnlyForSingleCallTagBrickSettings {
   public static readonly type = '[SingleCallTagBrickSettings] Change is read only for single call tag brick settings';

   constructor(public brickInstanceId, public isReadOnly: boolean) {}
}

export class ChangeEditBackgroundColorForSingleCallTagBrickSettings {
   public static readonly type = '[SingleCallTagBrickSettings] Change edit background color';

   constructor(public brickInstanceId, public backgroundColor: string) {}
}

export class ChangeEditFontColorForSingleCallTagBrickSettings {
   public static readonly type = '[SingleCallTagBrickSettings] Change edit font color';

   constructor(public brickInstanceId, public fontColor: string) {}
}

export class ChangeTagIconForSingleCallTagBrickSettings {
   public static readonly type = '[SingleCallTagBrickSettings] Change tag icon';

   constructor(public brickInstanceId, public tagIcon: IconDefinition) {}
}

export class ChangeTagIconColorForSingleCallTagBrickSettings {
   public static readonly type = '[SingleCallTagBrickSettings] Change tag icon color';

   constructor(public brickInstanceId, public iconColor: string) {}
}

export class ChangeTagEditorTypeForSingleCallTagBrickSettings {
   public static readonly type = '[SingleCallTagBrickSettings] Change tag editor type';

   constructor(public brickInstanceId, public editorType: EditorType) {}
}

export class ChangeTagEditorSettingsForSingleCallTagBrickSettings {
   public static readonly type = '[SingleCallTagBrickSettings] Change tag editor settings for single call tag brick settings';

   constructor(public brickInstanceId, public editorSettings: ConfigurableEditorSettingRemoteDto) {}
}

export class ChangeTagEditorPresentationTypeForSingleCallTagBrickSettings {
   public static readonly type = '[SingleCallTagBrickSettings] Change tag editor presentation type';

   constructor(public brickInstanceId, public presentationType: PresentationType) {}
}

export class ChangeTagEditorDescriptionTextForSingleCallTagBrickSettings {
   public static readonly type = '[SingleCallTagBrickSettings] Change tag editor description text';

   constructor(public brickInstanceId, public descriptionText: string) {}
}

export class ChangeShowDescriptionTextAsPopoverForSingleCallTagBrickSettings {
   public static readonly type = '[SingleCallTagBrickSettings] Change show description text as popover';

   constructor(public brickInstanceId, public showDescriptionTextAsPopover: boolean) {}
}

export class ChangeClearTagValueForSingleCallTagBrickSettings {
   public static readonly type = '[SingleCallTagBrickSettings] Change clear tag value';

   constructor(public brickInstanceId, public clearTagValue: string) {}
}

export class ChangeCallTagDisplayNameValueForSingleCallTagBrickSettings {
   public static readonly type = '[SingleCallTagBrickSettings] Change call tag display name';

   constructor(public brickInstanceId, public tagDisplayName: string) {}
}

export class ChangeCallTagSourceActiveCallForSingleCallTagBrickSettings {
   public static readonly type = '[SingleCallTagBrickSettings] Change call tag source active call';

   constructor(public brickInstanceId, public isEnabled: boolean) {}
}
export class ChangeCallTagSourceCallHistoryForSingleCallTagBrickSettings {
   public static readonly type = '[SingleCallTagBrickSettings] Change call tag source call history';

   constructor(public brickInstanceId, public isEnabled: boolean) {}
}
